<template>
  <div class="pb-3">
    <div class="px-7 max-w-xl mx-auto">
      <div
        v-if="errorMessage"
        class="text-xs my-2 text-center ion-text-red"
        v-html="errorMessage"
      ></div>
      <button
        expand="block"
        color="secondary"
        class="button-purple mb-9"
        :disabled="btnDisabled"
        @click="confirm"
      >
        <div class="flex items-center justify-center">
          <ion-spinner
            name="crescent"
            class="m-2"
            v-if="mfaSaving"
          ></ion-spinner>
          <span class="font-bold text-[14px] capitalize block text-white"
            >Confirm</span
          >
        </div>
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import router from "@/router";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { useBrowser } from "@/composables/browser";
import { useSecureStorage } from "@/composables/secureStorage";
import axios from "axios";
const customerStore = useCustomerStore();
const { keys, setStorage } = useSecureStorage();
const { urls } = useBrowser();
const {
  deviceID,
  environment,
  authToken,
  mfaSaving,
  mfaOptionSelected,
  mfaLoginContact,
  mfaVerificationCode,
  mfaVerificationCodeCompleted,
} = storeToRefs(customerStore);
const {
  setMfaSaving,
  setMfaUpdatedMsg,
  setMfaEnabled,
  setMfaLoginType,
  setMfaVerificationCodeCompleted,
} = customerStore;
const btnDisabled = computed(
  () => mfaSaving.value || !mfaVerificationCodeCompleted.value
);
const errorMessage = ref("");
const init = () => {
  setMfaSaving(false);
  errorMessage.value = "";
};
const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + authToken.value,
  },
};
const payload = computed(() => ({
  device_id: deviceID.value,
  code: mfaVerificationCode.value,
  environment: environment.value,
}));
const confirm = () => {
  setMfaSaving(true);
  axios
    .post(urls.apiMfaEnrolVerify, payload.value, headers)
    .then((response) => {
      setMfaSaving(false);
      setMfaVerificationCodeCompleted(false);
      if (response.status == 200) {
        setMfaUpdatedMsg(response.data.message);
        setMfaEnabled(true);
        setMfaLoginType(mfaOptionSelected.value);
        setStorage({
          key: keys.mfa,
          value: JSON.stringify({
            required: true,
            type: mfaOptionSelected.value,
            contact: mfaLoginContact.value,
            enabled: true,
          }),
        });
        router.push({ name: "MfaUpdated" });
      }
    })
    .catch((error) => {
      setMfaSaving(false);
      setMfaVerificationCodeCompleted(false);
      if (error) {
        errorMessage.value =
          error.status == 401
            ? "Invalid Code"
            : "There was an error processing your request. Please try again later.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 5000);
      }
    });
};
onMounted(() => {
  init();
});
</script>
